/**
 * An abstract base class for implementors of the basic Renderer API.
 */
var Renderer = (function () {
    function Renderer() {
    }
    /**
     * Gets an anchor for the ViewSlot to insert a view into.
     * @returns A DOM element.
     */
    Renderer.prototype.getDialogContainer = function () {
        throw new Error('DialogRenderer must implement getDialogContainer().');
    };
    /**
     * Displays the dialog.
     * @returns Promise A promise that resolves when the dialog has been displayed.
     */
    Renderer.prototype.showDialog = function (dialogController) {
        throw new Error('DialogRenderer must implement showDialog().');
    };
    /**
     * Hides the dialog.
     * @returns Promise A promise that resolves when the dialog has been hidden.
     */
    Renderer.prototype.hideDialog = function (dialogController) {
        throw new Error('DialogRenderer must implement hideDialog().');
    };
    return Renderer;
}());
export { Renderer };



//////////////////
// WEBPACK FOOTER
// ./~/aurelia-dialog/dist/native-modules/renderer.js
// module id = 81
// module chunks = 0